import { QueryClient } from '@tanstack/react-query';

/**
 * Shared QueryClient — must be cleared on logout/login so Account A data
 * cannot be served to Account B (query keys are not scoped by user id).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000,
    },
  },
});

export default queryClient;
